var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.config.options || [],"preserveSearch":true,"showNoResults":false,"select-label":"","deselect-label":"","placeholder":"Selecionar Perfil","selected-label":'Selecionado'},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }